import {
  checkExhaustive,
  checkExists,
} from 'external/dev_april_corgi+/js/common/asserts';
import * as corgi from 'external/dev_april_corgi+/js/corgi';

import {GraphEditorPage} from './graph_editor_page';
import {GraphsListPage} from './graphs_list_page';
import {RouteController, State} from './route_controller';

import './app.css';

export function App(
  props: {},
  state: State | undefined,
  updateState: (newState: State) => void,
) {
  if (!state) {
    state = RouteController.getInitialState();
  }

  let route;
  if (state.active.kind === 'graphsList') {
    route = <GraphsListPage />;
  } else if (state.active.kind === 'graphEditor') {
    route = <GraphEditorPage graphId={state.active.id} />;
  } else {
    throw checkExhaustive(state.active);
  }

  return (
    <div
      className="h-full w-full"
      js={corgi.bind({
        controller: RouteController,
        events: {
          render: 'wakeup',
        },
        state: [state, updateState],
      })}
    >
      {route}
    </div>
  );
}

if (process.env.CORGI_FOR_BROWSER) {
  corgi.hydrateElement(checkExists(document.getElementById('root')), <App />);
}
